/**
 * Part Finder V2 - Simple 2-level part finder (Brand > Model)
 * Handles dropdown selection and navigation to collections
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Parse models_raw text into models array
  function parseModelsList(modelsRaw, brandId) {
    if (!modelsRaw || typeof modelsRaw !== 'string') {
      return [];
    }

    const lines = modelsRaw.split(/\r?\n/).filter(line => line.trim() !== '');
    const models = [];
    
    lines.forEach((line, index) => {
      const trimmed = line.trim();
      if (!trimmed) return;
      
      // Split by | but preserve spaces in tag values
      // Format: Model Name|Tag|Collection Handle (optional)
      const pipeIndex = trimmed.indexOf('|');
      if (pipeIndex === -1) return;
      
      const modelName = trimmed.substring(0, pipeIndex).trim();
      const afterFirstPipe = trimmed.substring(pipeIndex + 1);
      
      // Find second pipe for collection handle (if exists)
      const secondPipeIndex = afterFirstPipe.indexOf('|');
      let modelTag, collectionHandle;
      
      if (secondPipeIndex === -1) {
        // No second pipe, everything after first pipe is the tag
        modelTag = afterFirstPipe.trim();
        collectionHandle = '';
      } else {
        // Second pipe exists, extract tag and collection handle
        modelTag = afterFirstPipe.substring(0, secondPipeIndex).trim();
        collectionHandle = afterFirstPipe.substring(secondPipeIndex + 1).trim();
      }
      
      // Fallback: if tag is empty, generate from model name
      if (!modelTag) {
        modelTag = 'model' + modelName;
      }
      
        if (modelName) {
        // Find collection from Shopify by name: "Part Finder_[Model Name]"
        // Mỗi model trong models_list tương ứng với một collection trong Shopify
        let foundCollectionUrl = '';
        let foundCollectionHandle = '';
        
        // Priority 1: If collection handle is provided in models_list, use it
        if (collectionHandle) {
          foundCollectionHandle = collectionHandle;
          foundCollectionUrl = '/collections/' + collectionHandle;
          console.log(`[Part Finder V2] Using provided collection handle: ${collectionHandle}`);
        } else {
          // Priority 2: Auto-find collection by exact name format: "Part Finder_[Model Name]"
          const collectionName = 'Part Finder_' + modelName;
          
          // Check if collections mapping exists
          if (window.partFinderV2Collections && typeof window.partFinderV2Collections === 'object') {
            // Try exact name match first (most reliable)
            if (window.partFinderV2Collections[collectionName]) {
              foundCollectionUrl = window.partFinderV2Collections[collectionName].url;
              foundCollectionHandle = window.partFinderV2Collections[collectionName].handle;
              console.log(`[Part Finder V2] ✅ Found collection by exact name: "${collectionName}" -> ${foundCollectionUrl}`);
            } else {
              // Try to find by searching all collections (handle variations)
              // Handle formats: part-finder-[model-name] or part-finder_[model-name]
              const normalizedModelName = modelName.toLowerCase().trim();
              const handleFormat1 = 'part-finder-' + normalizedModelName.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
              const handleFormat2 = 'part-finder_' + normalizedModelName.replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
              
              console.log(`[Part Finder V2] Searching collections for model: "${modelName}"`);
              console.log(`[Part Finder V2] Expected collection name: "${collectionName}"`);
              console.log(`[Part Finder V2] Trying handle formats: "${handleFormat1}" or "${handleFormat2}"`);
              
              // Search in collections mapping by handle
              for (const [name, collection] of Object.entries(window.partFinderV2Collections)) {
                const collectionNameLower = name.toLowerCase();
                const collectionHandle = collection.handle || '';
                
                // Match by handle
                if (collectionHandle === handleFormat1 || collectionHandle === handleFormat2) {
                  foundCollectionUrl = collection.url;
                  foundCollectionHandle = collection.handle;
                  console.log(`[Part Finder V2] ✅ Found collection by handle: "${name}" (handle: ${collectionHandle}) -> ${foundCollectionUrl}`);
                  break;
                }
                
                // Match by name (contains "Part Finder" and model name)
                if (collectionNameLower.includes('part finder') && 
                    collectionNameLower.includes(normalizedModelName)) {
                  foundCollectionUrl = collection.url;
                  foundCollectionHandle = collection.handle;
                  console.log(`[Part Finder V2] ✅ Found collection by name match: "${name}" -> ${foundCollectionUrl}`);
                  break;
                }
              }
              
              if (!foundCollectionUrl) {
                console.warn(`[Part Finder V2] ⚠️ Collection not found for model: "${modelName}"`);
                console.warn(`[Part Finder V2] Expected: "${collectionName}"`);
                console.warn(`[Part Finder V2] Available collections:`, Object.keys(window.partFinderV2Collections).filter(k => k.toLowerCase().includes('part finder')));
              }
            }
          } else {
            console.warn('[Part Finder V2] ⚠️ window.partFinderV2Collections is not available');
          }
        }
        
        console.log(`[Part Finder V2] Parsing model line ${index + 1}:`, {
          original: trimmed,
          modelName: modelName,
          modelTag: modelTag,
          collectionName: 'Part Finder_' + modelName,
          foundCollectionUrl: foundCollectionUrl,
          foundCollectionHandle: foundCollectionHandle
        });
        
        models.push({
          id: brandId + '_model_' + (index + 1),
          title: modelName,
          handle: modelName.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
          collection: foundCollectionHandle || collectionHandle,
          tag: modelTag,
          collection_url: foundCollectionUrl || (collectionHandle ? '/collections/' + collectionHandle : '')
        });
      }
    });
    
    return models;
  }

  function init() {
    console.log('[Part Finder V2] Initializing...');
    console.log('[Part Finder V2] window.partFinderV2Data available?', typeof window.partFinderV2Data !== 'undefined');
    
    const partFinderRoots = document.querySelectorAll('[data-partfinder-v2-root]');
    console.log('[Part Finder V2] Found root elements:', partFinderRoots.length);
    
    partFinderRoots.forEach((root, index) => {
      console.log(`[Part Finder V2] Processing root ${index + 1}:`, root);
      if (!root) {
        console.log('[Part Finder V2] Root is null, skipping');
        return;
      }
      
      const data = window.partFinderV2Data;
      console.log('[Part Finder V2] Data check:', {
        dataExists: !!data,
        hasBrands: !!(data && data.brands),
        brandsLength: data && data.brands ? data.brands.length : 0
      });
      
      if (!data || !data.brands || data.brands.length === 0) {
        console.log('[Part Finder V2] No data or brands found');
        showFeedback(root, window.partFinderV2Messages?.emptyData || 'No parts are configured for this page yet.');
        return;
      }

      // Parse models_raw into models for each brand
      data.brands.forEach(brand => {
        if (brand.models_raw && brand.models.length === 0) {
          console.log('[Part Finder V2] Parsing models_raw for brand:', brand.title);
          console.log('[Part Finder V2] models_raw content:', brand.models_raw);
          console.log('[Part Finder V2] Collections mapping available?', !!window.partFinderV2Collections);
          console.log('[Part Finder V2] Collections count:', window.partFinderV2Collections ? Object.keys(window.partFinderV2Collections).length : 0);
          
          brand.models = parseModelsList(brand.models_raw, brand.id);
          console.log('[Part Finder V2] Parsed', brand.models.length, 'models for brand:', brand.title);
          
          // Log each model's collection status
          brand.models.forEach((model, idx) => {
            console.log(`[Part Finder V2] Model ${idx + 1}: "${model.title}" -> Collection: ${model.collection_url || 'NOT FOUND'}`);
          });
          
          delete brand.models_raw; // Clean up
        }
      });

      const brandSelect = root.querySelector('[data-partfinder-select="brand"]');
      const modelSelect = root.querySelector('[data-partfinder-select="model"]');
      const searchButton = root.querySelector('[data-partfinder-search]');
      const resetButton = root.querySelector('[data-partfinder-reset]');
      const feedbackEl = root.querySelector('[data-partfinder-feedback]');

      console.log('[Part Finder V2] Found elements:', {
        brandSelect: !!brandSelect,
        modelSelect: !!modelSelect,
        searchButton: !!searchButton,
        resetButton: !!resetButton,
        feedbackEl: !!feedbackEl
      });

      if (!brandSelect || !modelSelect) {
        console.log('[Part Finder V2] Missing required select elements, aborting');
        return;
      }

      // Populate brand dropdown
      console.log('[Part Finder V2] Populating brands...');
      populateBrands(brandSelect, data.brands);
      console.log('[Part Finder V2] Brands populated. Options count:', brandSelect.options.length);

      // Handle brand change
      brandSelect.addEventListener('change', function() {
        const selectedBrandId = this.value;
        console.log('[Part Finder V2] Brand changed to:', selectedBrandId);
        
        if (selectedBrandId) {
          const brand = data.brands.find(b => b.id === selectedBrandId);
          console.log('[Part Finder V2] Found brand:', brand);
          
          if (brand && brand.models) {
            console.log('[Part Finder V2] Populating models for brand:', brand.title, 'Models count:', brand.models.length);
            populateModels(modelSelect, brand.models);
            modelSelect.disabled = false;
            modelSelect.value = '';
          } else {
            console.log('[Part Finder V2] No models found for brand');
            modelSelect.innerHTML = '<option value="">Select Model</option>';
            modelSelect.disabled = true;
          }
        } else {
          console.log('[Part Finder V2] No brand selected, disabling model select');
          modelSelect.innerHTML = '<option value="">Select Model</option>';
          modelSelect.disabled = true;
        }
        clearFeedback(feedbackEl);
      });

      // Handle search button click
      if (searchButton) {
        searchButton.addEventListener('click', function(e) {
          console.log('[Part Finder V2] Search button clicked!', e);
          handleSearch(root, brandSelect, modelSelect, data, feedbackEl);
        });
      } else {
        console.log('[Part Finder V2] Warning: Search button not found!');
      }

      // Handle reset button click
      if (resetButton) {
        resetButton.addEventListener('click', function() {
          brandSelect.value = '';
          modelSelect.value = '';
          modelSelect.disabled = true;
          modelSelect.innerHTML = '<option value="">Select Model</option>';
          clearFeedback(feedbackEl);
        });
      }

      // Handle Enter key on selects
      [brandSelect, modelSelect].forEach(select => {
        select.addEventListener('keypress', function(e) {
          if (e.key === 'Enter' && searchButton) {
            searchButton.click();
          }
        });
      });
    });
  }

  function populateBrands(select, brands) {
    const placeholder = select.querySelector('option[value=""]');
    select.innerHTML = '';
    if (placeholder) {
      select.appendChild(placeholder);
    }

    brands.forEach(brand => {
      const option = document.createElement('option');
      option.value = brand.id;
      option.textContent = brand.title;
      select.appendChild(option);
    });
  }

  function populateModels(select, models) {
    const placeholder = select.querySelector('option[value=""]');
    select.innerHTML = '';
    if (placeholder) {
      select.appendChild(placeholder);
    }

    // Ensure models is an array
    if (!Array.isArray(models)) {
      console.error('[Part Finder V2] Error: models is not an array:', typeof models, models);
      return;
    }

    console.log('[Part Finder V2] populateModels called with', models.length, 'models');
    models.forEach((model, index) => {
      if (!model || typeof model !== 'object') {
        console.error('[Part Finder V2] Invalid model at index', index, ':', model);
        return;
      }
      
      if (!model.id || !model.title) {
        console.error('[Part Finder V2] Model missing id or title at index', index, ':', model);
        return;
      }

      const option = document.createElement('option');
      option.value = model.id;
      option.textContent = String(model.title); // Ensure it's a string
      option.dataset.collection = model.collection || '';
      option.dataset.collectionUrl = model.collection_url || '';
      select.appendChild(option);
      console.log('[Part Finder V2] Added model option:', model.id, model.title);
    });
  }

  function handleSearch(root, brandSelect, modelSelect, data, feedbackEl) {
    console.log('=== [Part Finder V2] Go button clicked ===');
    console.log('[Part Finder V2] Root element:', root);
    console.log('[Part Finder V2] Brand select:', brandSelect);
    console.log('[Part Finder V2] Model select:', modelSelect);
    console.log('[Part Finder V2] Data object:', data);
    
    const brandId = brandSelect.value;
    const modelId = modelSelect.value;
    
    console.log('[Part Finder V2] Selected Brand ID:', brandId);
    console.log('[Part Finder V2] Selected Model ID:', modelId);

    // Validation
    if (!brandId) {
      console.log('[Part Finder V2] Validation failed: No brand selected');
      showFeedback(feedbackEl, window.partFinderV2Messages?.chooseOption || 'Please select at least one option to continue.');
      return;
    }

    // Find selected brand
    const brand = data.brands.find(b => b.id === brandId);
    console.log('[Part Finder V2] Found brand:', brand);
    
    if (!brand) {
      console.log('[Part Finder V2] Error: Brand not found in data');
      showFeedback(feedbackEl, window.partFinderV2Messages?.missingUrl || 'Unable to open the selected option. Please choose another.');
      return;
    }

    let targetUrl = null;

    // If model is selected, use model collection URL
    if (modelId) {
      console.log('[Part Finder V2] Model ID provided, searching for model...');
      console.log('[Part Finder V2] Looking for modelId:', modelId);
      console.log('[Part Finder V2] brand.models type:', Array.isArray(brand.models) ? 'Array' : typeof brand.models);
      console.log('[Part Finder V2] brand.models length:', brand.models ? brand.models.length : 'N/A');
      console.log('[Part Finder V2] All model IDs in brand:', brand.models ? brand.models.map(m => ({ id: m?.id, title: m?.title })) : 'N/A');
      
      // Safe check for brand.models
      if (!brand.models || !Array.isArray(brand.models)) {
        console.log('[Part Finder V2] Error: brand.models is not an array or is undefined');
        showFeedback(feedbackEl, 'Invalid data structure. Please refresh the page.');
        return;
      }
      
      // Filter out any null/undefined models and find the matching one
      const validModels = brand.models.filter(m => m != null);
      console.log('[Part Finder V2] Valid models count:', validModels.length, 'out of', brand.models.length);
      
      const model = validModels.find(m => m.id === modelId);
      console.log('[Part Finder V2] Found model:', model);
      
      if (model) {
        console.log('[Part Finder V2] Model details:', {
          id: model.id,
          title: model.title,
          handle: model.handle,
          collection: model.collection,
          collection_url: model.collection_url,
          tag: model.tag
        });
        
        // Logic đơn giản: Tìm collection theo tên từ CSV
        // Format: "Part Finder_[Model Name]" -> collection handle: "part-finder-[model-name]"
        
        // Priority 1: Use assigned collection_url or collection handle
        if (model.collection_url && model.collection_url !== '') {
          targetUrl = model.collection_url;
          console.log('[Part Finder V2] ✅ Using assigned collection_url:', targetUrl);
        } else if (model.collection && model.collection !== '') {
          targetUrl = `/collections/${model.collection}`;
          console.log('[Part Finder V2] ✅ Using assigned collection handle:', targetUrl);
        } else {
          // Priority 2: Try to find collection in mapping by model title
          const modelTitle = model.title || '';
          const collectionName = 'Part Finder_' + modelTitle;
          
          // Try to find in collection mapping
          if (window.partFinderV2Collections && typeof window.partFinderV2Collections === 'object') {
            if (window.partFinderV2Collections[collectionName]) {
              targetUrl = window.partFinderV2Collections[collectionName].url;
              console.log('[Part Finder V2] ✅ Found collection in mapping:', collectionName, '->', targetUrl);
            } else {
              // Try handle formats: part-finder_[model-name] or part-finder-[model-name]
              const handleFormat1 = 'part-finder-' + modelTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-');
              const handleFormat2 = 'part-finder_' + modelTitle.toLowerCase().replace(/[^a-z0-9]+/g, '_');
              
              for (const [name, collection] of Object.entries(window.partFinderV2Collections)) {
                if (collection.handle === handleFormat1 || collection.handle === handleFormat2) {
                  targetUrl = collection.url;
                  console.log('[Part Finder V2] ✅ Found collection by handle:', name, '->', targetUrl);
                  break;
                }
              }
              
              // If still not found, try partial match
              if (!targetUrl) {
                for (const [name, collection] of Object.entries(window.partFinderV2Collections)) {
                  if (name.toLowerCase().includes('part finder') && 
                      name.toLowerCase().includes(modelTitle.toLowerCase())) {
                    targetUrl = collection.url;
                    console.log('[Part Finder V2] ✅ Found collection by partial match:', name, '->', targetUrl);
                    break;
                  }
                }
              }
            }
          }
          
          // Final fallback: generate handle (may not exist in Shopify)
          if (!targetUrl) {
            const collectionHandle = 'part-finder-' + modelTitle.toLowerCase()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, '');
            targetUrl = `/collections/${collectionHandle}`;
            console.log('[Part Finder V2] ⚠️ Collection not found in mapping, using generated handle:', targetUrl);
          }
        }
      } else {
        console.log('[Part Finder V2] Model not found in brand.models');
        console.log('[Part Finder V2] Available models:', brand.models);
        console.log('[Part Finder V2] Searching for modelId:', modelId);
        showFeedback(feedbackEl, 'Selected model not found. Please try selecting again.');
        return;
      }
    } else {
      console.log('[Part Finder V2] No model selected, using brand only');
    }

    console.log('[Part Finder V2] Final target URL:', targetUrl);

    // Navigate to collection URL
    if (targetUrl && targetUrl !== '') {
      console.log('[Part Finder V2] ✅ Navigating to collection:', targetUrl);
      window.location.href = targetUrl;
    } else {
      console.log('[Part Finder V2] ❌ No URL to navigate to');
      showFeedback(feedbackEl, 'Unable to find products. Please try selecting different options.');
    }
    console.log('=== [Part Finder V2] End of handleSearch ===');
  }

  function showFeedback(element, message) {
    if (element) {
      element.textContent = message;
      element.style.display = 'block';
      element.setAttribute('aria-live', 'polite');
    }
  }

  function clearFeedback(element) {
    if (element) {
      element.textContent = '';
      element.style.display = 'none';
    }
  }
})();

